<template>
  <div class="page" id="credit">
    <div class="top">
      <div class="realname">Hi, <span>{{$global.realname}}</span>!</div>
      <img src="@/assets/iconPoints.png" alt="">
      <div class="tp">Total Points</div>
      <div class="points">{{totalPoint}}</div>
      <div class="point-today-container">
        <img src="@/assets/iconTodayPoi.png" alt="">
        <div class="right">
          <div class="point-today">{{todayPoint}} Points</div>
          <div class="text">You got {{todayPoint}} points today!</div>
        </div>
      </div>
    </div>

    <div class="bottom">
      <div class="title">Integration Rule</div>
      <div class="list">

        <div class="item">
          <div class="title">
            获取积分途径：观看视频、参与答题、上传作品”。The ways to get points: Watch video、Participate in quiz、Upload work
          </div>
        </div>

        <!-- <div class="item">
          <div class="title">1. 观看视频</div>
          <div class="detail">每看一个视频可积分2分，每日最多积分8分。</div>
        </div>
        <div class="item">
          <div class="title">2. 参与答题</div>
          <div class="detail">每次答题可积分3分，每日最多积分9分。</div>
        </div>
        <div class="item">
          <div class="title">3. 上传作品</div>
          <div class="detail">上传作品，老师打分。</div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import index from "./index.js";
export default { ...index };
</script>

<style lang="scss">
@import "./index.scss";
</style>